/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import Timepicker from './Timepicker';
import Time from '../numbers/Time';

class TimepickerButton extends React.Component {

    state: State = {
        keyboardVisible: false
    };

    static propTypes = {
        value: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.number
        ]).isRequired,
        className: React.PropTypes.string.isRequired,
        removedClassName: React.PropTypes.string,
        onSubmit: React.PropTypes.func.isRequired,
        label: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.openKeyboard = this.openKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    openKeyboard(open) {
        this.setState({keyboardVisible: open});
    }

    onSubmit(val) {
        const {onSubmit} = this.props;
        onSubmit(val);
        this.openKeyboard(false);
    }

    render() {
        const {keyboardVisible} = this.state;
        const {value, className, removedClassName, label} = this.props;

        const cn = keyboardVisible ? className.replace(removedClassName, '') : className;

        return (
            <div className={cn}>
                <div className="boxBtn-inner"
                     onClick={() => this.openKeyboard(true)}>
                    <Time value={value}/>
                </div>
                {keyboardVisible &&
                    <Timepicker defaultValue={value}
                                label={label}
                                onClose={() => this.openKeyboard(false)}
                                onSubmit={this.onSubmit}/>
                }
            </div>
        );
    }
}

export default connect(state => ({}))(TimepickerButton);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/TimepickerButton.js